// Warms the browser's HTTP cache for the 3D configurator's fixed JS/CSS/WASM
// payload (the same files Configurator.jsx loads) so that by the time someone
// actually opens /configurator, those files are a cache hit instead of a
// multi-hundred-KB download. GLB models are deliberately left out: there are
// many of them and they're only needed once the user picks a product inside
// the configurator, so prefetching all of them on every page would waste
// bandwidth for no benefit.
const CONFIGURATOR_ASSETS = [
  '/configurator/css/styles.css',
  '/configurator/js/runtime-config.js',
  '/configurator/js/orion-site-shim.js',
  '/configurator/js/config-loader.js',
  '/configurator/js/glb-prefetch.js',
  '/configurator/js/vendor/three.min.js',
  '/configurator/js/orion-gltf.js',
  '/configurator/js/vendor/three/three.module.js',
  '/configurator/js/vendor/three/loaders/GLTFLoader.js',
  '/configurator/js/vendor/three/loaders/DRACOLoader.js',
  '/configurator/js/vendor/three/draco/draco_wasm_wrapper.js',
  '/configurator/js/vendor/three/draco/draco_decoder.wasm',
  '/configurator/js/cart.js',
  '/configurator/js/configurator-pricing.js',
  '/configurator/js/cabinet3d.js',
  '/configurator/js/custom-configurator.js',
];

const SESSION_KEY = 'cfg-assets-prefetched';

export function prefetchConfiguratorAssets() {
  if (window.location.pathname.startsWith('/configurator')) return;
  if (sessionStorage.getItem(SESSION_KEY) === '1') return;

  const run = () => {
    CONFIGURATOR_ASSETS.forEach((href) => {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      document.head.appendChild(link);
    });
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch {
      /* private mode / quota — not worth failing over */
    }
  };

  // Idle + after the page's own load event, so this never competes with the
  // current page's own critical requests.
  const schedule = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 4000 });
    } else {
      setTimeout(run, 1500);
    }
  };

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }
}
